import { SignUpTemplate } from 'layouts/SignUpTemplate';
import { Header } from 'layouts/SignUpTemplate/components/Header';
import * as React from 'react';
import { Form } from './Form';
import { Success } from './Success';

interface PromptStage {
  stage: 'prompt';
}
interface SuccessStage {
  stage: 'success';
}
type State = PromptStage | SuccessStage;

export const ChangePassword: React.FC = () => {
  const [state, setState] = React.useState<State>({ stage: 'prompt' });

  let content;
  let header = '';
  switch (state.stage) {
    case 'success':
      content = <Success />;
      header = 'Your password was reset!';
      break;
    case 'prompt':
    default:
      content = <Form onSuccess={() => setState({ stage: 'success' })} />;
      header = 'Reset your password';
      break;
  }

  return (
    <SignUpTemplate>
      <div className="flex items-center flex-col space-y-16">
        <Header header={header} />
        {content}
      </div>
    </SignUpTemplate>
  );
};
